export type SquadRow = {
  rank: number;
  delta?: number;
  name: string;
  frags: number;
  tk: number;
  survival: number;
  attendance: number;
  vehicleFrags: number;
  infantryFrags: number;
  med: number;
  ksEfficiency: number;
  ego: number;
  efficiency: number;
  championCount?: number;
  badge?: {
    icon: string;
    title: string;
  };
};

export type SquadColumnKey = keyof SquadRow;

export type SquadColumn = {
  key: SquadColumnKey;
  label: string;
  type: 'number' | 'string';
};

export const squadColumns: SquadColumn[] = [
  { key: 'rank', label: 'Рейтинг', type: 'number' },
  { key: 'name', label: 'Отряд', type: 'string' },
  { key: 'frags', label: 'Фраги', type: 'number' },
  { key: 'tk', label: 'ТК', type: 'number' },
  { key: 'survival', label: 'Выживаемость', type: 'number' },
  { key: 'attendance', label: 'Посещаемость', type: 'number' },
  { key: 'vehicleFrags', label: 'Врага убито техникой', type: 'number' },
  { key: 'infantryFrags', label: 'Врага убито пехотой', type: 'number' },
  { key: 'med', label: 'МЕД', type: 'number' },
  { key: 'ksEfficiency', label: 'КС КПД', type: 'number' },
  { key: 'ego', label: 'ЧСВ', type: 'number' },
  { key: 'efficiency', label: 'КПД', type: 'number' },
];

export const squadDefaultSort: { key: SquadColumnKey; direction: 'asc' | 'desc' } = {
  key: 'efficiency',
  direction: 'desc',
};
